"use client";

import React from "react";
import { Link } from "@/components/common/Link";
function EstatePlanningHero() {
  return <section data-section-id="262237" id="estate-planning-hero" className="bg-background py-12 text-foreground lg:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-start lg:gap-14">
          <div>
            <p className="mb-3 font-default text-xs uppercase tracking-[0.25em]" style={{
            color: "var(--secondary)"
          }}>
              Wills, Trusts &amp; Probate
            </p>

            <h1 className="max-w-3xl font-default font-light leading-[1.03] tracking-tight text-primary text-4xl sm:text-5xl lg:text-[56px]" style={{
            fontFamily: "var(--font-serif)"
          }}>Will, Trust, and Probate Matters Begin with Organized Information</h1>

            <p className="mt-6 max-w-2xl font-default text-lg leading-relaxed md:text-xl" style={{
            color: "var(--muted-foreground)"
          }}>The Law Office of Morrie I. Levine assists South Florida clients with probate administration, trust-related matters, wills presented in probate, beneficiary issues, estate assets, creditor claims, real estate interests, business interests, and related court proceedings.<div><br /></div><div>Each matter begins with identifying the relevant people, property, accounts, governing documents, ownership arrangements, beneficiary designations, and any court papers or deadlines that may affect the administration or dispute.</div></p>

            

            <div className="mt-8">
              <Link to="/ContactUsPage" className="inline-flex items-center justify-center rounded-md bg-primary px-7 py-3.5 font-default text-sm font-medium text-primary-foreground no-underline transition-opacity hover:opacity-90">
                Request a Consultation
              </Link>
            </div>
          </div>

          <div className="border-t pt-6 lg:pt-8" style={{
          borderColor: "var(--border)"
        }}>
            <p className="mb-5 font-default text-xs uppercase tracking-[0.25em]" style={{
            color: "var(--secondary)"
          }}>Probate and Trust Background</p>

            <h2 className="font-default text-3xl font-light leading-tight text-foreground md:text-4xl" style={{
            fontFamily: "var(--font-serif)"
          }}>Review Informed by Legal and Financial Considerations</h2>

            <div className="mt-7 space-y-6 font-default text-base leading-relaxed md:text-lg" style={{
            color: "var(--muted-foreground)"
          }}>
              <p>Morrie I. Levine studied estate planning during law school, providing an early foundation for later work involving wills, trusts, probate administration, and the legal transfer of property after death.<div><br /></div><div>Will, trust, and probate matters often require attention to more than one document. Real estate ownership, business interests, beneficiary designations, account ownership, trust provisions, and court records may all affect the appropriate course of action.</div><div><br /></div><div>The firm’s approach begins with organized information and document review before determining what administration, interpretation, court filing, or other legal action may be required.</div></p>

              

              
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export default EstatePlanningHero;